<div class="d-flex flex-column h-100">
  <!-- Header -->
  <app-header></app-header>

  <!-- Main content (router outlet) -->
  <main class="flex-fill overflow-auto">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
